import { render, staticRenderFns } from "./AdhaaarDetails.vue?vue&type=template&id=45c5830a"
import script from "./AdhaaarDetails.vue?vue&type=script&lang=js"
export * from "./AdhaaarDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports